export type DcEnvironmentCode = 'prod' | 'develop' | 'local';

export type DcEnvironmentName = 'Production' | 'Develop' | 'Local';

export type DcEnvironmentHostPrefix = '.dev' | '.local' | undefined;

export interface DcEnvironment {
  readonly code: DcEnvironmentCode;
  readonly name: DcEnvironmentName;
  readonly hostPrefix?: DcEnvironmentHostPrefix;
}

const SUPPORTED_ENVIRONMENTS: Record<DcEnvironmentCode, Omit<DcEnvironment, 'code'>> = {
  prod: {
    name: 'Production',
  },
  develop: {
    name: 'Develop',
    hostPrefix: '.dev',
  },
  local: {
    name: 'Local',
    hostPrefix: '.local',
  },
} as const;

export function getDcEnvironmentFromCode(code: DcEnvironmentCode): DcEnvironment {
  const env = SUPPORTED_ENVIRONMENTS[code];
  if (!env) {
    throw new Error(`Unsupported environment code: ${code}`);
  }
  return { ...env, code };
}

// Not sure if any of this is necessary but it is in the .Net version code
// class DcEnvironmentHelpers {
//   public static fromString(code: DcEnvironmentCode): DcEnvironment {
//     return getDcEnvironmentFromCode(code);
//   }

//   public static equals(b: DcEnvironment, a: DcEnvironmentCode): boolean;
//   public static equals(a: DcEnvironmentCode, b: DcEnvironment): boolean;
//   public static equals(x: DcEnvironment | DcEnvironmentCode, y: DcEnvironment | DcEnvironmentCode): boolean {
//     if (typeof x === 'object' && x !== null && 'code' in x && typeof y === 'string') {
//       return x.code === y;
//     }
//     if (typeof x === 'string' && typeof y === 'object' && y !== null && 'code' in y) {
//       return y.code === x;
//     }
//     return false;
//   }

//   public static notEquals(a: DcEnvironment, b: string): boolean;
//   public static notEquals(a: string, b: DcEnvironment): boolean;
//   public static notEquals(x: DcEnvironment | string, y: DcEnvironment | string): boolean {
//     return !DcEnvironmentHelpers.equals(x as any, y as any);
//   }
// }
